import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../event_invite';

export default function Launcher(props) {
  const config = useDialogConfig();

  const event = useConnect('event.byId', {
    id: config.params.eventId
  });

  if (event.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      event={event}
      onClose={props.onClose}
    />
  );
};
